import { useEffect, useState } from 'react';
import { FileText, Mail, Briefcase, Star, Images, MessageSquare, AlertCircle } from 'lucide-react';
import api from '@/lib/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/admin/stats').then(r => setStats(r.data)).catch(() => {});
  }, []);

  const cards = stats ? [
    { label: 'Devis reçus', value: stats.devis_count, sub: `${stats.devis_nouveau} nouveau${stats.devis_nouveau > 1 ? 'x' : ''}`, icon: FileText, color: 'brand' },
    { label: 'Messages contact', value: stats.contacts_count, icon: Mail, color: 'emerald' },
    { label: 'Candidatures', value: stats.applications_count, icon: Briefcase, color: 'amber' },
    { label: 'Avis publiés', value: stats.reviews_published, sub: `${stats.reviews_pending} en attente`, icon: Star, color: 'amber' },
    { label: 'Photos galerie', value: stats.gallery_count, icon: Images, color: 'brand' },
    { label: 'Conversations IA', value: stats.chat_sessions_count || 0, sub: `${stats.chat_messages_count || 0} messages`, icon: MessageSquare, color: 'brand' },
  ] : [];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="h2 text-anthracite-950">Tableau de bord</h1>
        <p className="text-muted-foreground mt-1">Vue d'ensemble de l'activité du site</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map(c => (
          <div key={c.label} className="card-base p-5" data-testid={`admin-stat-${c.label.toLowerCase().replace(/\s/g, '-')}`}>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">{c.label}</p>
                <p className="text-3xl font-heading font-semibold text-anthracite-950 mt-1">{c.value}</p>
                {c.sub && <p className="text-xs text-muted-foreground mt-1">{c.sub}</p>}
              </div>
              <div className="h-12 w-12 rounded-xl bg-brand-50 text-brand-700 flex items-center justify-center">
                <c.icon className="h-6 w-6" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card-base p-5 bg-amber-50 border-amber-200">
        <div className="flex items-start gap-3">
          <AlertCircle className="h-5 w-5 text-amber-700 shrink-0" />
          <div>
            <p className="font-medium text-amber-900">Bienvenue dans l'espace admin</p>
            <p className="text-sm text-amber-800 mt-1">Naviguez via le menu à gauche pour gérer les demandes de devis, contacts, candidatures, avis et la galerie photos.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
